import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import {
  AppearanceAnimation,
  DialogLayoutDisplay,
  DisappearanceAnimation,
  ToastPositionEnum,
  ToastProgressBarEnum,
  ToastUserViewTypeEnum
} from '@costlydeveloper/ngx-awesome-popup';
import { DsAuthJWTToken, DsAuthService, DsHTTPStatus } from '@direction/auth';
import { NotifyService } from '@direction/message';
import { ResourceService } from '@direction/translate';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GlobalUser } from './core/models/global.user.model';
import { CredentialEntered, TypeMessageSignalR } from './core/models/socketMessage';
import { Status } from './core/models/status';
import { StatusSignalR } from './core/models/statusSignalR';
import { HelpersService } from './core/services/helpers.service';
import { TurnstileService } from './core/services/turnstile.service';
import { UserService } from './core/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  isValidToken = false;
  showComponent = false;
  eventCatraca: any;

  unitCode: string;
  programCodes: string;

  statusSignalR: StatusSignalR = StatusSignalR.Unknown;

  constructor(
    private ns: NotifyService,
    router: Router,
    private resource: ResourceService,
    private titleService: Title,
    private turnstileService: TurnstileService,
    public helpersService: HelpersService,
    private authService: DsAuthService,
    httpStatus: DsHTTPStatus,
    spinner: NgxSpinnerService,
    private userService: UserService
  ) {
    this.resource.setCulture(navigator.language).then(() => {
      this.titleService.setTitle(resource.getResource('@metadata.title'));
    });
    this.ns.config.width = 'auto';
    router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe(() => {
      ns.clearAllToast();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    httpStatus.getHttpStatus().subscribe((status: boolean) => {
      if (status) {
        spinner.show();
      } else {
        spinner.hide();
      }
    });

    this.turnstileService.getUnitCode().subscribe((unitCode) => {
      this.unitCode = unitCode;
    });

    this.turnstileService.eventSignalR$.subscribe((response) => {
      this.statusSignalR = response.status;
      if (this.statusSignalR == StatusSignalR.LogoutUser) {
        this.turnstileService.connection.stop();
      }

      if (this.statusSignalR != 5) {
        if (response?.type == TypeMessageSignalR.CredentialEntered) {
          if (response.data[0].unitCode === this.unitCode) {
            this.showPopUp(response.data);
          }
        }
      }
    });

    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('/auth') || event.url.includes(environment.notAuthorizedRoute)) {
          this.showComponent = false;
        } else {
          this.showComponent = true;
        }
      }
    });
  }

  ngOnInit() {
    this.statusSignalR = StatusSignalR.Unknown;
    this.authService.onTokenChange().subscribe((token: DsAuthJWTToken) => {
      if (token.isValid()) {
        this.userService.getLoggedUser().subscribe((user: GlobalUser) => {
          this.userService.setMyInfo(user);
        });
        this.isValidToken = true;
        this.resource.setCulture(JSON.parse(token.getPayload().user).cultureCode);

        this.subscribeCatracaService();
      } else {
        this.isValidToken = false;
        this.unsubscribeCatracaService();
      }
    });
  }

  subscribeCatracaService() {
    if (
      this.statusSignalR == StatusSignalR.Unknown ||
      this.statusSignalR == StatusSignalR.LogoutUser ||
      this.statusSignalR == StatusSignalR.Disconnected
    ) {
      this.eventCatraca = this.turnstileService.initConnection().subscribe((data) => {
        if (data.disconnected) {
          this.unsubscribeCatracaService();
          return;
        }
        this.turnstileService.studentsByDay$.next('plus');
      });
    }
  }

  unsubscribeCatracaService() {
    if (this.eventCatraca) {
      this.eventCatraca.unsubscribe();
    }
    setTimeout(() => {
      // Se o status não foi que o usuário "saiu" da aplicação ou é o status inicial, então pode tentar conectar novamente
      if (this.statusSignalR != StatusSignalR.LogoutUser && this.statusSignalR != StatusSignalR.Unknown) {
        this.subscribeCatracaService();
      }
    }, 5000);
  }

  showPopUp(data: CredentialEntered[]) {
    let delay = 3000; // Seta o delay padrão.
    if (data[0]?.birthdate) {
      // Checagem se é aniversariante
      let monthToday = new Date(Date.now()).getMonth();
      let dateToday = new Date(Date.now()).getDate();
      let dateStudent = new Date(this.helpersService.isoToShortDate(data[0].birthdate));

      if (monthToday === dateStudent.getMonth() && dateToday === dateStudent.getDate()) {
        delay = 7000; // Seta um delay maior pra poder tocar a musica completa.
        this.turnstileService.playAudioHappyBirthday();
      }
    }

    let htmlString = `<div class='ds-toast'><div class='${
      data[0].eventId
    }'><div class='row mb-2 d-flex justify-content-center'><img src='${this.completedBase64(
      data[0].photo
    )}' width='100'></div><div class='ml-2'><div class='row font-weight-bold'>${this.resource.getResource(
      '@direction.pages.popupCredential.name'
    )}</div><div class='row text-left'>${data[0].name}</div><div class='row mt-1 font-weight-bold'>${this.resource.getResource(
      '@direction.pages.popupCredential.nationalId'
    )}</div><div class='row'>${this.helpersService.maskCpf(
      data[0].nationalId
    )}</div><div class='row mt-1 font-weight-bold'>${this.resource.getResource(
      '@direction.pages.popupCredential.status'
    )}</div><div class='row font-weight-bold text-success'>${this.resource.getResource(
      Status.getMessage(data[0].statusCode)
    )}</div></div></div></div>`;
    this.helpersService.showToast(
      DialogLayoutDisplay.CUSTOM_ONE,
      'Registro de entrada',
      htmlString,
      ToastPositionEnum.BOTTOM_RIGHT,
      delay,
      ToastProgressBarEnum.DECREASE,
      ToastUserViewTypeEnum.SIMPLE,
      AppearanceAnimation.SLIDE_IN_RIGHT,
      DisappearanceAnimation.SLIDE_OUT_RIGHT
    );
  }

  completedBase64(base64?: string) {
    var prefix = '/assets/images/noPicture.webp';
    if (!base64) return prefix;
    if (base64.startsWith('/9j/4')) prefix = 'data:image/jpg;base64,';
    if (base64.startsWith('iVBOR')) prefix = 'data:image/png;base64,';
    if (base64.startsWith('UklGR')) prefix = 'data:image/octet-stream;base64,';
    if (base64.startsWith('JVBER')) prefix = 'data:application/pdf;base64,';
    return prefix + base64;
  }
}
